// 📁 src/redux/slices/ISBNBookBubOptionsSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

// ✅ Types
interface ISBNBookBubOption {
  label: string;
  value: string;
}

interface FetchISBNBookBubParams {
  page?: number;
  limit?: number;
  searchTerm?: string | null | any;
  ISBN?: any;
  TITLE?: any;
  DEAL_DATE?: any;
}

interface ISBNBookBubOptionsState {
  ISBNBookBubOption: any;
  isbn:any;
  loading: boolean;
  error: string | null;
  hasMore: boolean;
  currentPage: number;
  limit: number;
  LoadingofISBNBookBub:boolean
  LoadingofTitleBookBUb:boolean
  LoadingofDealBookBub:boolean
}

// ✅ Initial State
const initialState: ISBNBookBubOptionsState = {
  ISBNBookBubOption: [],
  loading: false,
  isbn:[],
  error: null,
  hasMore: true,
  currentPage: 1,
  limit: 10,
  LoadingofTitleBookBUb:false,
    LoadingofDealBookBub:false,
  LoadingofISBNBookBub:false
};

export const FetchISBNBookBub = createAsyncThunk(
  "FetchISBNBookBub",
  async (params: FetchISBNBookBubParams = {}, { rejectWithValue }) => {
    try {
      const queryParams: string[] = [];

      if (params.page !== undefined) queryParams.push(`page=${params.page}`);
      if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
      if (params.searchTerm !== undefined)
        queryParams.push(`searchTerm=${params.searchTerm}`);
      // if (params.DATE?.length) queryParams.push(`DATE=${params.DATE}`);
      if (Array.isArray(params.ISBN)) {
        params.ISBN.forEach((isbn) => {
          queryParams.push(`ISBN=${encodeURIComponent(isbn)}`);
        });
      }
      if (Array.isArray(params.TITLE)) {
        params.TITLE.forEach((title) => {
          queryParams.push(`TITLE=${encodeURIComponent(title)}`);
        });
      }
      if (Array.isArray(params.DEAL_DATE)) {
        params.DEAL_DATE.forEach((file) => {
          queryParams.push(`DEAL_DATE=${encodeURIComponent(file)}`);
        });
      }

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await axios.get(
        `${API.GetBookbubISbnOptions}${queryString}`
      );

      return {
        data: response.data,
        page: params.page ?? 1,
      };
      
    } catch (err: any) {
      if (err.response?.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

const ISBNBookBubOptionsSlice = createSlice({
  name: "ISBNBookBubOptions",
  initialState,
  reducers: {
    clearISBNBookBubOptions: (state) => {
      state.ISBNBookBubOption = [];
      state.currentPage = 1;
      state.hasMore = true;
      state.loading = false;
      state.error = null;
    },
    setLoadingofISBNBookBUb:(state,action)=>{
      state.LoadingofISBNBookBub=action.payload
    },
    setLoadingofTitleBookBub:(state,action)=>{
      state.LoadingofTitleBookBUb=action.payload
    },
    setLoadingofDealBookBub:(state,action)=>{
      state.LoadingofDealBookBub=action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchISBNBookBub.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchISBNBookBub.fulfilled, (state, action) => {
        const { data, page } = action.payload;

        const formatted = (data?.bookbub_isbn_options || []).map(
          (item: string) => ({
            label: item,
            value: item,
          })
        );
        console.log(formatted,"isbn_options");
        if (page === 1) {
          state.ISBNBookBubOption = formatted;
        } else {
          state.ISBNBookBubOption = [
            ...state.ISBNBookBubOption,
            ...formatted,
          ];
        }

        state.currentPage = page;
        state.hasMore = data.hasMore;
        state.loading = false;
      })
      .addCase(FetchISBNBookBub.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) ?? "Fetch failed";
      });
  },
});

export const { clearISBNBookBubOptions ,setLoadingofDealBookBub,setLoadingofISBNBookBUb,setLoadingofTitleBookBub} =
  ISBNBookBubOptionsSlice.actions;
export default ISBNBookBubOptionsSlice.reducer;
